import React from 'react';
import styled from 'styled-components';
import { checkPixel } from 'utils';

export function MainTitle({ title, children, ...props }) {
  return (
    <TitleBox {...props}>
      <Title>
        <Circle />
        <h2>
          FARM:IN&nbsp;<span>{title}</span>
        </h2>
      </Title>
    </TitleBox>
  );
}

const TitleBox = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  margin: 0 auto 48px;
  max-width: 1440px;
  padding: ${({ $padding }) => ($padding && $padding) || '0 24px'};
  gap: 24px;

  @media ${({ theme }) => theme.device.mobile} {
    gap: 16px;
    margin: 0 auto 24px;
  }
`;

const Circle = styled.span`
  width: ${({ $width }) => ($width && checkPixel($width)) || '22px'};
  height: ${({ $height }) => ($height && checkPixel($height)) || '22px'};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.device.mobile} {
    width: ${({ $mWidth }) => ($mWidth && checkPixel($mWidth)) || '14px'};
    height: ${({ $mHeight }) => ($mHeight && checkPixel($mHeight)) || '14px'};
  }
`;

const Title = styled.div`
  display: flex;

  h2 {
    font-size: 2.75rem;
    line-height: 1.2;
    color: ${({ theme }) => theme.colors.secondary800};
  }

  span {
    font-weight: 400;
  }

  @media ${({ theme }) => theme.device.tablet} {
    width: 100%;
  }

  @media ${({ theme }) => theme.device.mobile} {
    h2 {
      font-size: 1.5rem;
      line-height: 1.5;
    }
  }
`;
